import React, { useRef, useState } from "react";
import { Box, Typography, TextField, IconButton } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import { Event } from "../Events";

interface TrainingProps {
  eventData: Event;
}

interface Message {
  id: number;
  content: string;
  sender: "user" | "ai";
  timestamp: Date;
}

const Training: React.FC<TrainingProps> = ({ eventData }) => {
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState<Message[]>([]);
  const [loading, setLoading] = useState(false);
  const messagesEndRef = useRef<HTMLDivElement | null>(null);

  console.log("eventData", eventData);

  const handleSend = async () => {
    if (!message.trim()) return;

    // Add user message
    const userMessage: Message = {
      id: messages.length,
      content: message,
      sender: "user",
      timestamp: new Date(),
    };

    setMessages((prev) => [...prev, userMessage]);
    setMessage("");
    setLoading(true);

    // Simulate AI response (this will be replaced with actual RavenAI integration)
    setTimeout(() => {
      const aiMessage: Message = {
        id: messages.length + 1,
        content:
          "This is a placeholder AI response. RavenAI integration coming soon.",
        sender: "ai",
        timestamp: new Date(),
      };
      setMessages((prev) => [...prev, aiMessage]);
      setLoading(false);
    }, 1000);
  };

  const scrollToBottom = () => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  React.useEffect(() => {
    scrollToBottom();
  }, [messages]);

  return (
    <Box
      bgcolor="background.paper"
      borderRadius={1}
      boxShadow={1}
      display="flex"
      flexDirection="column"
      height="85vh"
      position="relative"
    >
      <Box flexGrow={1} p={2} overflow="auto" pb={8}>
        {messages.map((msg) => (
          <Box
            key={msg.id}
            sx={{
              display: "flex",
              justifyContent: msg.sender === "user" ? "flex-end" : "flex-start",
              mb: 2,
            }}
          >
            <Box
              sx={{
                maxWidth: "70%",
                bgcolor: msg.sender === "user" ? "primary.main" : "grey.100",
                color: msg.sender === "user" ? "white" : "text.primary",
                borderRadius: 2,
                p: 2,
              }}
            >
              <Typography>{msg.content}</Typography>
            </Box>
          </Box>
        ))}
        {loading && (
          <Typography
            variant="body2"
            sx={{ fontStyle: "italic", color: "text.secondary" }}
          >
            AI is typing...
          </Typography>
        )}
        <div ref={messagesEndRef} />
      </Box>
      <Box
        component="form"
        display="flex"
        alignItems="center"
        p={1}
        bgcolor="background.paper"
        borderTop={`1px solid divider`}
        position="absolute"
        bottom={0}
        left={0}
        right={0}
        zIndex={1}
      >
        <TextField
          variant="outlined"
          fullWidth
          placeholder="Ask RavenAI about this event..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyPress={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              handleSend();
            }
          }}
          sx={{ borderRadius: 20 }}
        />
        <IconButton onClick={handleSend} color="primary">
          <SendIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default Training;
